<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="mb-1">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="10">
        <h1 class="page-title">Orders
        </h1>
    </div>
</div>
<div>
    <h2 class="">QuickBooks
    </h2>
</div>
<div nz-row>

    <div class="gutter-row mb-1" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="8">
        <div class="d-flex change_ship_date">
        <div class="date-filter-div">
            <input type="text" class="form-control date-picker input mr-1" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selectedDateRangeQBO" (ngModelChange)="onDateChangeQBO($event)" placeholder="Filter By Invoice Date"
                [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'right'" [showClearButton]="false"
                [showClearButton]="false">
        </div>
        <div class="date-filter-div w-37">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButtonInv">
                <input type="text" class="input" nz-input placeholder="Search invoice number here ..."
                    [(ngModel)]="searchTextInvoice"  (keydown.enter)="searchByInvoice()" (keydown)="searchByInvoice()" />
            </nz-input-group>
            <ng-template #suffixIconButtonInv>
                <button class="search-btn" nz-button nzType="primary" nzSearch (click)="searchByInvoice()"><span nz-icon
                        nzType="search"></span></button>
            </ng-template>
        </div>
        </div>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="4" nzOffset="1">
        <div class="date-filter-div w-37 ml-1">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                <input type="text" class="input" nz-input placeholder="Search BL status here ..."
                    [(ngModel)]="searchTextBLStatus" (keydown.enter)="searchByBL()" (keydown)="searchByBL()" />
            </nz-input-group>
            <ng-template #suffixIconButton>
                <button class="search-btn" nz-button nzType="primary" nzSearch (click)="searchByBL()"><span nz-icon
                        nzType="search"></span></button>
            </ng-template>
        </div>
    </div>
</div>
<!--(scrolled)="onScrollDown()"-->
<!-- <div class="table-heightQBO mb-1" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" > -->
    <nz-table class="main-table-header statusTable" #sortTable [nzData]="quickbooksData" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{y:'calc((100vh - 450px)/2)'}"
        [ngClass]="{'table-loading' : quickbooksData.length > 0 || isLoadingQBOData}">
        <thead>
            <tr class="tableheader">
                <th nzWidth="180px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'invoiceDate')">
                    Invoice Date
                </th>
                <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'invoiceNumber')">QB
                    Invoice#
                </th>
                <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event,'customerName')">QB Customer
                    Name
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'blStatus')">QB BL
                    Status</th>
                <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'po')">PO
                </th>
                <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'shipDate')">QB
                    Ship Date
                </th>
                <th nzWidth="113px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortquickbooksData($event, 'paymentStatus')">
                    QB Pmt Status</th>

                <th nzWidth="180px" [nzAlign]="'left'">Assigned</th>
            </tr>
        </thead>
        <tbody *ngIf="!isLoadingQBOData">
            <ng-container *ngFor="let data of quickbooksData;let i = index;let even=even;">
                <tr>

                    <td [nzAlign]="'left'">
                       {{ (data.invoiceDate.toString() | date : 'MM/dd/yyyy') ==
                            '01/01/0001'? '-' : (data.invoiceDate.toString() | date : 'MM/dd/yyyy') }}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.invoiceNumber.length > 10 ? data.invoiceNumber : ''"><a [href]="data.qboInvoiceDeepLink" [ngClass]="!data.qboInvoiceDeepLink ? 'c-n-allow' : ''" (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null"
                        target="_blank">{{
                        data.invoiceNumber }}</a></td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.customerName"> <a [href]="data.zohoContactDeepLink" [ngClass]="!data.zohoContactDeepLink ? 'c-n-allow' : ''" (click)="!data.zohoContactDeepLink ? $event.preventDefault() : null"
                        target="_blank">{{data.customerName}}</a></td>
                    <td [nzAlign]="'left'">{{data.blStatus ? (data.blStatus | uppercase) : '-'}} </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.po.lnegth > 10 ? (data.po) : ''"><a [href]="data.woocommerceOrderDeepLink" [ngClass]="!data.woocommerceOrderDeepLink ? 'c-n-allow' : ''" (click)="!data.woocommerceOrderDeepLink ? $event.preventDefault() : null"
                        target="_blank">{{
                        data.po ? (data.po) : '-' }}</a>
                    </td>
                    <td [nzAlign]="'left'" >
                        
                       {{ (data.shipDate.toString() | date : 'MM/dd/yyyy') ==
                       '01/01/0001'? '-' : (data.shipDate.toString() | date : 'MM/dd/yyyy') }}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip 
                        [nzTooltipTitle]="data.paymentStatus.length > 10 ? (data.paymentStatus) : ''"><span [ngClass]="data.paymentStatus == 'UnPaid' ? 'unpaid' : data.paymentStatus == 'Paid' ? 'paid' : 'partial-paid'" class="status-text">{{
                        data.paymentStatus ? (data.paymentStatus) : '-' }}</span>
                    </td>
                    <!--(click)="!data.isAssigned ? showAssignmentModal(data) : null"-->
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [ngClass]="!data.isAssigned ? 'cursor' : ''"
                        [nzTooltipTitle]="data.stockDetail?.join(',')"><a style="display: contents;" (click)="showAssignmentModal(data, true)" [ngClass]="data.isAssigned ? 'ellipsis' : ''">{{ data.isAssigned ?
                        "Yes (" + data.stockDetail?.join(',') + ')' : '' }}</a> <button *ngIf="!data.isAssigned" (click)="showAssignmentModal(data)" nz-button nzType="primary" class="right_margin new-btn inline-btn ml-4">Assign</button> 
                    </td>
                    <!-- <img *ngIf="data.isAssigned" (click)="showAssignmentModal(data, true)" src="../assets/images/edit.svg"> -->
                </tr>
            </ng-container>
        </tbody>
        <ng-container *ngIf="isLoadingQBOData">
            <tbody>
                <tr *ngFor="let i of [].constructor(5)">
                    <ng-container *ngFor="let i of [].constructor(8)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
<!-- </div> -->
<div>
    <h2 class="">WooCommerce
    </h2>
</div>
<div class="mb-1" nz-row>
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="11">
        <div class="d-flex">
        <div class="date-filter-div w-37">
            <input type="text" class="form-control date-picker input mr-1" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selectedDateRangeWOO" (ngModelChange)="onDateChangeWOO($event)" placeholder="Filter By Order Date"
                [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'right'" [drops]="'up'" [showClearButton]="false"
                [showClearButton]="false">
        </div>
    <!-- <div nz-col nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="4"> -->
        <div class="date-filter-div w-37">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButtonOrder">
                <!--(keyup)="onSearch($event)"  search-input-->
                <input type="text" class="input" nz-input placeholder="Search order number here ..."
                    [(ngModel)]="searchTextOrder"  (keydown.enter)="searchByOrderNumber()" (keydown)="searchByOrderNumber()"/>
            </nz-input-group>
            <ng-template #suffixIconButtonOrder>
                <button class="search-btn" nz-button nzType="primary" nzSearch (click)="searchByOrderNumber()"><span nz-icon
                        nzType="search"></span></button>
            </ng-template>
        </div>
        </div>
    </div>
    <!-- </div> -->
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="4">
        <div class="date-filter-div w-37">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButtonStatus">
                <!--(keyup)="onSearch($event)"  search-input-->
                <input type="text" class="input" nz-input placeholder="Search woo status here ..."
                    [(ngModel)]="searchTextWooStatus"  (keydown.enter)="searchByOrderStatus()" (keydown)="searchByOrderStatus()"/>
            </nz-input-group>
            <ng-template #suffixIconButtonStatus>
                <button class="search-btn" nz-button nzType="primary" nzSearch (click)="searchByOrderStatus()"><span nz-icon
                        nzType="search"></span></button>
            </ng-template>
        </div>
    </div>
</div>
<!-- (scrolled)="onScrollDownOrders()"-->
<!-- <div class="table-heightWoo" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false"> -->
    <nz-table class="main-table-header statusTable" #sortTable [nzData]="wooCommerceData" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{y:'calc((100vh - 450px)/2)'}"
        [ngClass]="{'table-loading' : wooCommerceData.length > 0 || isDataLoading}">
        <thead>
            <tr class="tableheader">
                <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'orderDate')">
                    Order Date
                </th>
                <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'orderNumber')">
                    Order Number
                </th>
                <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'cutomerName')">
                    Woo Customer Name
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'orderStatus')">
                    Woo Status
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'qboInvoiceNo')">
                    QB Invoice#
                </th>
                <th nzWidth="130px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortWooCommerceData($event, 'orderPaymentType')">
                    Woo Pmt Type
                </th>
            </tr>
        </thead>
        <tbody *ngIf="!isDataLoading">
            <ng-container *ngFor="let data of wooCommerceData;let i = index;let even=even;">
                <tr>

                    <td [nzAlign]="'left'">
                        {{(data.orderDate.toString() | date : 'MM/dd/yyyy') ==
                        '01/01/0001'? '-'
                        : (data.orderDate.toString() | date : 'MM/dd/yyyy' )}}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.orderNumber.length > 10 ? data.orderNumber : ''"><a (click)="!data.woocommerceOrderDeepLink ? $event.preventDefault() : null" [href]="data?.woocommerceOrderDeepLink" [ngClass]="!data.woocommerceOrderDeepLink ? 'c-n-allow' : ''" 
                        target="_blank">{{
                        data.orderNumber }}</a></td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.cutomerName.length > 10 ? data.cutomerName : ''"><a [ngClass]="!data.zohoCustomerDeepLink ? 'c-n-allow' : ''" (click)="!data.zohoCustomerDeepLink ? $event.preventDefault() : null" [href]="data.zohoCustomerDeepLink"
                        target="_blank">{{data.cutomerName}}</a></td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.orderStatus.length > 10 ? data.orderStatus : ''">{{
                            data.orderStatus }} </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.qboInvoiceNo.length > 10 ? data.qboInvoiceNo : ''"><a [ngClass]="!data.qboInvoiceNo ? 'c-n-allow' : ''"  (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null" [href]="data.qboInvoiceDeepLink"
                        target="_blank">{{
                        data.qboInvoiceNo ? data.qboInvoiceNo : '-' }}</a>
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.orderPaymentType.length > 10 ? data.orderPaymentType : ''">{{ data.orderPaymentType ?
                        data.orderPaymentType : '-' }}
                    </td>
                </tr>

            </ng-container>
        </tbody>
        <ng-container *ngIf="isDataLoading">
            <tbody>
                <tr *ngFor="let i of [].constructor(5)">
                    <ng-container *ngFor="let i of [].constructor(6)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
<!-- </div> -->


<app-add-update-assignment *ngIf="isAssignmentVisible" [assignemntForInvoice]="assignemntForInvoice" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideModal($event)">
</app-add-update-assignment>